import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

export function fetchAppUpdateTimeline({ trackId, countryCode, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/${countryCode}/app-update-timeline?${paramsToQuery({
    startDate,
    endDate,
  })}`)
}

/**
 * Retrieves A/B Test data for given trackIds and optional parameters from the Play Store.
 *
 * @param {object} params - The params for the request.
 * @param {string} params.trackId - app trackId.
 * @param {string} params.countryCode - country ISO code.
 * @param {string} params.date - YYYY-MM-DD.
 * @param {string[]} params.differences - app update types
 *
 * @returns {Promise} The Promise object representing the HTTP request.
 */
export function getAppScreenshots({ trackId, countryCode, date, differences }) {
  return makeRequest(`/app/versions/single/${trackId}/${countryCode}?date=${date}`, {
    method: 'POST',
    data: differences,
  })
}
